/**
 * Contact page Gorgias FOUC bridge.
 * Soft-hides `.contact-gorgias-form` briefly, then always reveals —
 * either on CONTACT_INLINE_READY from Extra HTML, or a short fallback.
 * Never leave the mount invisible forever.
 *
 * Also answers CONTACT_LOCALE_REQUEST from the Gorgias iframe (Extra HTML)
 * with this storefront page's locale, since the iframe is cross-origin and
 * cannot reliably read it via document.referrer.
 */
(function () {
  var SOURCE = 'ultimate-setup-contact-gorgias';
  var READY_CLASS = 'is-ready';
  var FALLBACK_MS = 2500;
  var revealed = false;

  /* Must match the locale keys defined in the Gorgias Contact Extra HTML's COPY object. */
  var SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it', 'es', 'ar'];

  function mounts() {
    return document.querySelectorAll('.contact-gorgias-form');
  }

  function reveal() {
    if (revealed) return;
    var nodes = mounts();
    if (!nodes.length) return;
    revealed = true;
    var i;
    for (i = 0; i < nodes.length; i++) {
      nodes[i].classList.add(READY_CLASS);
    }
  }

  /*
   * The Gorgias form renders inside a cross-origin iframe (contact.gorgias.help),
   * so its script cannot read window.location.pathname of this storefront page —
   * and document.referrer is unreliable there (origin-only under the browser's
   * default strict-origin-when-cross-origin policy). Read the real page locale
   * here instead and hand it to the iframe over postMessage.
   */
  function detectPageLocale() {
    try {
      var segments = (window.location.pathname || '/').split('/').filter(Boolean);
      if (!segments.length) return 'de';
      var first = String(segments[0] || '').toLowerCase();
      if (SUPPORTED_LOCALES.indexOf(first) !== -1) return first;
      var short = first.split('-')[0];
      if (SUPPORTED_LOCALES.indexOf(short) !== -1) return short;
    } catch (e) { /* ignore */ }
    return 'de';
  }

  function postLocale(targetWindow) {
    if (!targetWindow) return;
    try {
      targetWindow.postMessage(
        { source: SOURCE, type: 'CONTACT_LOCALE', locale: detectPageLocale() },
        '*'
      );
    } catch (e) {
      /* Ignore cross-origin delivery failures. */
    }
  }

  function onMessage(event) {
    var data = event && event.data;
    if (!data || typeof data !== 'object') return;
    if (data.source !== SOURCE) return;
    if (data.type === 'CONTACT_INLINE_READY') reveal();
    if (data.type === 'CONTACT_LOCALE_REQUEST') postLocale(event.source);
  }

  function bind() {
    if (!mounts().length) return false;
    window.addEventListener('message', onMessage);
    window.setTimeout(reveal, FALLBACK_MS);
    /*
     * Push the locale proactively once the Gorgias iframe's own document
     * has loaded, in case its request arrives before this listener is
     * attached. Do NOT reveal() here: the iframe's load event only means
     * Gorgias's raw/unstyled document loaded, not that Extra HTML has
     * finished enhancing it — revealing on this signal showed a flash of
     * the native, un-translated form before CONTACT_INLINE_READY. Only
     * CONTACT_INLINE_READY and the FALLBACK_MS safety net reveal now.
     */
    var nodes = mounts();
    var i;
    for (i = 0; i < nodes.length; i++) {
      var iframe = nodes[i].querySelector('iframe');
      if (iframe) {
        iframe.addEventListener('load', function () {
          postLocale(iframe.contentWindow);
        });
      }
    }
    return true;
  }

  if (bind()) return;

  /* Mount may appear after deferred Gorgias loader — watch briefly */
  if (typeof MutationObserver === 'undefined') {
    window.setTimeout(function () {
      bind();
      window.setTimeout(reveal, FALLBACK_MS);
    }, 1000);
    return;
  }

  var observer = new MutationObserver(function () {
    if (bind()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    observer.disconnect();
    bind();
    reveal();
  }, 6000);
})();
